import { Box, Button, ButtonAppearance, ButtonSize, Modal, ModalSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const ModalFooterStyled = styled(Box).attrs({
  p: { sm: '300' },
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;
export const DrawerFooterButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
})`
  ${({ theme }) => css`
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    padding: ${theme.spacings[500]};
  `}
`;

export const ModalCloseStyled = styled.div`
  position: absolute;
  ${({ theme }) => css`
    right: ${theme.spacings[400]};
    top: ${theme.spacings[100]};
  `}
`;

export const ModalStyled = styled(Modal).attrs({
  size: ModalSize.DEFAULT,
})`
  width: 50%;
  max-width: 50%;
  height: 80%;
  max-height: 80%;
`;
